
import api from "@/api";
import { EmailTemplate } from "@/api/dtos/EmailTemplate.schema";
import Documents from "@/components/admin/Documents.vue";
import OperatorDocuments from "@/components/operator/Documents.vue";
import Faq from "@/components/admin/Faq.vue";
import DeviceTypeAdministrationTable from "@/components/admin/DeviceTypeAdministrationTable.vue";
import UserManagement from "@/components/admin/UserManagement.vue";
import EmailTemplates from "@/components/operator/EmailTemplates.vue";
import { Component, Vue } from "vue-property-decorator";
import SectionNav, { Section } from "@/components/SectionNav.vue";

@Component({
  components: {
    EmailTemplates,
    Faq,
    Documents,
    OperatorDocuments,
    UserManagement,
    SectionNav,
    DeviceTypeAdministrationTable,
  },
})
export default class AdminView extends Vue {
  templates: EmailTemplate[] = [];

  async mounted(): Promise<void> {
    this.templates = await api.MailTemplatesApi.getMailTemplates();
  }

  sectionList: Section[] = [
    {
      id: "user-management",
      label: "Nutzer",
    },
    {
      id: "faq",
      label: "FAQ",
    },
    {
      id: "email",
      label: "Email-Vorlagen",
    },
    {
      id: "documents",
      label: "Formulare",
    },
    {
      id: "types",
      label: "Boxtypen",
    },
    {
      id: "properties",
      label: "Eigenschaften",
    },
  ];
}
